<ion-card [routerLink]="['/main-courante-item/', declaration().id]" [state]="{ declaration: declaration() }">
  <ion-card-content>
    <div>
      <fa-icon [icon]="isAnomalie() ? faExclamationCircle : faInfoCircle" [ngClass]="isAnomalie() ? 'danger' : 'success'"> </fa-icon>
      <span class="heure">{{ declaration().instant.toDate() | date: 'HH:mm' }}</span>
      @if (declaration().declareePourZone) {
        <div class="declaree_pour_zone" [translate]="'mainCourante.declareeSurLaZone'"></div>
      }
    </div>
    <div>
      {{ declaration().texte ?? '' | truncate: [160, '...'] }}
    </div>
    @if (declaration().photos.length > 0) {
      <div class="nbPics"><fa-icon [icon]="faCamera"></fa-icon> {{ declaration().photos.length }}</div>
    }
  </ion-card-content>
</ion-card>
